import React from 'react'

function GameRules() {
  return (
    <div className="flex flex-col items-center min-h-screen mt-20">
        <div>
            Game Rules
        </div>
    </div>
  )
}

export default GameRules